import cn from 'classnames';
import PropTypes from 'prop-types';
import { useState, forwardRef } from 'react';

import { SideNavContextProvider } from './SideNavContext.jsx';

import MenuAside from './MenuAside.jsx';
import PageContentColumn from './PageContentColumn.jsx';

function LdsSideNav({
  sideNavContactLillyExpand,
  sideNavContactLillyCollapse,
  postMenu,
  languageSelector,
  languagesFirst = false,
  logo,
  regulatoryLinks,
  hasSearch = false,
  searchEnabled = false,
  sideNavSearchText = '',
  preMenu,
  contactLilly,
  contactFirst = false,
  sideNavMenuText = 'Menu',
  sideNavExpandedText = 'Menu opened',
  sideNavCollapsedText = 'Menu closed',
  sideNavCloseText = 'Close',
  mobileMenuExpanding = false,
  setSearchValue = () => {},
  onSearchSubmit = () => {},
  searchValue,
  stickyContent,
  children,
  menu,
  routerLink,
  currentRoute,
  navContainerAriaLabel = 'primary',
  className,
  ...rest
}, ref) {
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  return (
    <SideNavContextProvider
      menu={menu}
      currentRoute={currentRoute}
      setShowMobileMenu={setShowMobileMenu}
      showMobileMenu={showMobileMenu}
    >
      <div
        id="SideNavParent"
        className={cn(
          'lds-side-nav-wrapper',
          {
            expanded: showMobileMenu,
          },
          className
        )}
        ref={ref}
        {...rest}
      >
        <MenuAside
          menu={menu}
          sideNavContactLillyExpand={sideNavContactLillyExpand}
          sideNavContactLillyCollapse={sideNavContactLillyCollapse}
          postMenu={postMenu}
          languageSelector={languageSelector}
          languagesFirst={languagesFirst}
          logo={logo}
          regulatoryLinks={regulatoryLinks}
          hasSearch={hasSearch}
          searchEnabled={searchEnabled}
          sideNavSearchText={sideNavSearchText}
          preMenu={preMenu}
          contactLilly={contactLilly}
          contactFirst={contactFirst}
          sideNavMenuText={sideNavMenuText}
          sideNavExpandedText={sideNavExpandedText}
          sideNavCollapsedText={sideNavCollapsedText}
          sideNavCloseText={sideNavCloseText}
          mobileMenuExpanding={mobileMenuExpanding}
          setSearchValue={setSearchValue}
          onSearchSubmit={onSearchSubmit}
          searchValue={searchValue}
          routerLink={routerLink}
          setShowMobileMenu={setShowMobileMenu}
          showMobileMenu={showMobileMenu}
          navContainerAriaLabel={navContainerAriaLabel}
        />
        <PageContentColumn
          stickyContent={stickyContent}
        >
          {children}
        </PageContentColumn>
      </div>
    </SideNavContextProvider>
  );
}

export default forwardRef(LdsSideNav);

LdsSideNav.propTypes = {
  hasSearch: PropTypes.bool,
  setSearchValue: (props, propName, componentName) => {
    if ((props?.hasSearch === true && (props[propName] === undefined || typeof (props[propName]) !== 'function'))) {
      return new Error(`LDS ERROR >> Invalid prop "${propName}" supplied to ${componentName}.
        Prop "${propName}" is a required funcion when "hasSearch" is true.
      `);
    }
    return null;
  },
  onSearchSubmit: (props, propName, componentName) => {
    if ((props?.hasSearch === true && (props[propName] === undefined || typeof (props[propName]) !== 'function'))) {
      return new Error(`LDS ERROR >> Invalid prop "${propName}" supplied to ${componentName}.
        Prop "${propName}" is a required funcion when "hasSearch" is true.
      `);
    }
    return null;
  },

};
